// Store listings offered by the top-bar "Get the app" QR dropdown.
// An app section renders only when it has at least one URL. Names are the real store names on every instance — partner-box
// users (Navcore) install the same binaries via multi-server discovery.
export const APP_LINKS = [
  {
    id: 'command',
    name: 'Trackizy Command',
    audienceKey: 'appLinks.forManagers',
    ios: 'https://apps.apple.com/app/id6784803901',
    android: 'https://play.google.com/store/apps/details?id=io.appaka.trackizyfleet',
  },
  {
    id: 'staff',
    name: 'Trackizy Staff',
    audienceKey: 'appLinks.forFieldWorkers',
    // iOS listing is UNLISTED on the App Store — reachable only by direct link,
    // which is exactly what this QR is.
    ios: 'https://apps.apple.com/app/id6793234912',
    android: 'https://play.google.com/store/apps/details?id=io.appaka.trackizystaff',
  },
];

/** Apps worth showing: at least one store URL configured. */
export function availableApps(links = APP_LINKS) {
  return links.filter((app) => !!app.ios || !!app.android);
}
